<head>
  <meta name="robots" content="index, follow">
  <meta name="description" content="Soluciones tecnológicas para la gestión de eventos. Ofrecemos: ticketing, control de accesos, pagos cashless a través de tecnología RFID y marketing y CRM.">
  <title></title>
</head>
<div [ngClass]="themeService.selectedTheme" style="background-color: #FFFFFF"
     id="theme-container" #div>
  @if (!loaded) {
    <bracelit-preloader [absoluteCentered]="true"></bracelit-preloader>
  }
  @if (loaded) {
    <router-outlet></router-outlet>
  }
</div>
